import * as msal from '@azure/msal-browser';

// MSAL Configuration
export const localMsalConfig = {
    auth: {
        clientId: "cf312bef-3d62-4d4f-8ce7-a9277bb8d41f",
        authority: 'https://login.microsoftonline.com/db505480-8ec6-495c-b579-32c58ed84a01',
        redirectUri: "http://localhost:8080"
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            logLevel: msal.LogLevel.Verbose,
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case msal.LogLevel.Error:
                        console.error(message);
                        return;
                    case msal.LogLevel.Info:
                        console.info(message);
                        return;
                    case msal.LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case msal.LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

export const webMsalConfig = {
    auth: {
        clientId: "ce37242e-3b4f-4ef8-8ecc-c765328dacc2",
        authority: 'https://login.microsoftonline.com/db505480-8ec6-495c-b579-32c58ed84a01'
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
};


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/msal/msalConfig.ts
 **/